import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../LatestNews/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function LatestNewsCreate() {
    const [title, setTitle] = useState("");
    const [date, setDate] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState("");
  
    
    const navigate = useNavigate();


    const handleSubmit = async (e) => {

        console.log("access  token data will be",ACCESS_TOKEN_NAME())
        e.preventDefault();
        
        const formData = new FormData();
        formData.append("name", title);
        formData.append("date", date);
        formData.append("description", description);
        formData.append("status", status);
    
        console.log("fnmfnmfnffmmnfmffmnmf  fkkfjf",description)
        // return false
        const headers = {
            "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
            "Content-Type": "multipart/form-data",
        };

        try {
            const response = await axios.post(`${API_BASE_URL}/createLatestStoriesNews/null`, formData, { headers });
            if (response.status === 200) {
                navigate("/admin/latestNewsList");
            } else {
                console.error("Error: Unexpected response status", response.status);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    return (
        <>
            <div>
                <Header />
                <div className="main-container">
                    <AdminNavbar />
                    <div className="main">
                        <div className="report-container">
                            <div className="report-header">
                                <h1 className="recent-Articles">Create Latest News & Stories</h1>
                            </div>
                            <div className="report-body">
                                <div className="user-form">
                                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                                        <div className="mb-3">
                                            <label htmlFor="title" className="form-label">Title</label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                id="title" 
                                                name="title" 
                                                value={title} 
                                                onChange={(e) => setTitle(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="date" className="form-label">Date</label>
                                            <input 
                                                type="date" 
                                                className="form-control"
                                                id="date" 
                                                name="date" 
                                                value={date} 
                                                onChange={(e) => setDate(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label">Description</label>
                                            <ReactQuill 
                                                theme="snow" 
                                                value={description} 
                                                onChange={setDescription}
                                            />
                                        </div>
                                        <div className="mb-3 mt-3">
                                            <label htmlFor="status" className="form-label">
                                                Latest News Status
                                            </label>
                                            <select 
                                                className="form-control" 
                                                id="status" 
                                                value={status} 
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <option value="">Select Status</option>
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>

                                        
                                      

                                        <button type="submit" className="btn btn-primary submit-btn">
                                            CREATE
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LatestNewsCreate;
